import React, { Component } from 'react'
import FontAwesomeIcon from 'react-fontawesome'
import { messageTypes } from '../../../actions/messages'
import { Tooltip } from 'antd'

class StyledRebootButton extends Component {
  render () {
    const { reboot, status, stack, stackActionStatus, language } = this.props
    const rebootDisabled = reboot === false || stack?.status !== 'poweredon' || status !== 'poweredOn' || stackActionStatus !== undefined

    return (
      <Tooltip placement='top' title={rebootDisabled ? (stackActionStatus !== undefined ? messageTypes[language].reboot_is_disabled_stack_turned_off : messageTypes[language].reboot_is_disabled) : ''}>
        <div
          onClick={() => rebootDisabled ? null : this.props.handleClick(this.props.id)}
          disabled={rebootDisabled}
          className={rebootDisabled ? 'vm-action-disabled' : ''}
        >
          <FontAwesomeIcon
            name='power-off'
            pulse={status === 'rebooting'}
          />
          {messageTypes[language].reboot}
        </div>
      </Tooltip>
    )
  }
}

export default StyledRebootButton
